import React from "react";

function ReactPoolIcon({
    title,
    titleId,
    ...props
}, svgRef) {
    return /*#__PURE__*/React.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/React.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/React.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M23.2,9.74,8.54,35.12a2.23,2.23,0,0,0,1.93,3.35H39.79a2.23,2.23,0,0,0,1.93-3.35L27.06,9.74A2.23,2.23,0,0,0,23.2,9.74Z M2.12,35.44l18-29.18a.53.53,0,0,1,.9.54L3.84,36.46a1,1,0,0,1-1.72-1Z"
    }));
};

export default React.forwardRef(ReactPoolIcon);

export const PoolIcon = ({ classes }) => (
    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45 45" className={classes}>
        <defs>
            <style>
                {/* .cls-1,.cls-3{fill:none;stroke:#238c23;stroke-linecap:round;stroke-linejoin:round;}.cls-1{stroke-width:2px;}.cls-2{fill:#238c23;}.cls-3{stroke-width:1.8px;} */}
            </style>
        </defs>
        <path
            className="cls-1"
            style={{
                fill: "none",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2px",
            }}
            d="M23.2,9.74,8.54,35.12a2.23,2.23,0,0,0,1.93,3.35H39.79a2.23,2.23,0,0,0,1.93-3.35L27.06,9.74A2.23,2.23,0,0,0,23.2,9.74Z"
        />
        <path
            className="cls-2"
            style={{
                fill: "none",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
            }}
            d="M2.12,35.44l18-29.18a.53.53,0,0,1,.9.54L3.84,36.46a1,1,0,0,1-1.72-1Z"
        />
        <circle style={{ strokeWidth: "1.4px", stroke: "currentColor", fill: "currentColor" }} cx="14.98" cy="33.47" r="2" />
        <circle style={{ strokeWidth: "1.4px", stroke: "currentColor", fill: "currentColor" }} cx="21.75" cy="33.47" r="2" />
        <circle style={{ strokeWidth: "1.4px", stroke: "currentColor", fill: "currentColor" }} cx="28.51" cy="33.47" r="2" />
        <circle style={{ strokeWidth: "1.4px", stroke: "currentColor", fill: "currentColor" }} cx="35.27" cy="33.47" r="2" />
        <circle style={{ strokeWidth: "1.4px", stroke: "currentColor", fill: "currentColor" }} cx="18.37" cy="27.62" r="2" />
        <circle style={{ strokeWidth: "1.4px", stroke: "currentColor", fill: "currentColor" }} cx="25.13" cy="27.62" r="2" />
        <circle style={{ strokeWidth: "1.4px", stroke: "currentColor", fill: "currentColor" }} cx="31.89" cy="27.62" r="2" />
        <circle style={{ strokeWidth: "1.4px", stroke: "currentColor", fill: "currentColor" }} cx="21.75" cy="21.76" r="2" />
        <circle style={{ strokeWidth: "1.4px", stroke: "currentColor", fill: "currentColor" }} cx="28.51" cy="21.76" r="2" />
        <circle style={{ strokeWidth: "1.4px", stroke: "currentColor", fill: "currentColor" }} cx="25.13" cy="15.91" r="2" />
    </svg>
);
